import React, {Component} from "react";
import{
    Row,
    Col,
    Card,
    CardBody,
    CardFooter,
    UncontrolledTooltip
} from 'reactstrap';
import { Link,NavLink } from "react-router-dom";
import DatePicker from "react-datepicker";
import swal from 'sweetalert';
import LoadingScreen, { __esModule } from 'react-loading-screen';
import NumberFormat from 'react-number-format';

import moment from 'moment-timezone';
import Breadcrumbs from '../../component/Breadcrumb';
import logo from "../../images/logo/logo.png";
import API from '../../helpers/API';
import{
    infoSession,
    showRole,
    showStatusAktif,
} from '../../config/Utils';
import "react-datepicker/dist/react-datepicker.css";
moment.tz.setDefault("Asia/Makassar");

class Supplier extends Component {
    constructor(props){
        super(props);
        this.state = {
            isReady:false,
            isLoading:false,
            xOperator:infoSession('nama'),
            dataTable:[],
            fCari:'',
            xId:'',
            xNama:'',
            xAlamat:'',
            xNoTlp:'',
        }

        this._handleInputChange=this._handleInputChange.bind(this);
    }

    _handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    _clearBox(){
        this.setState({
            xId:'',
            xNama:'',
            xAlamat:'',
            xNoTlp:''
        });
    }

    _loadDataTable(param){
        var filter = {
            cari:param
        };

        API.get('supplier',{params:filter}).then(res=>{
            let ar = [];
            if(res.data.result){
                if(res.data.data.length){
                    ar=res.data.data;
                };
            };
            this.setState({
                dataTable:ar,
                isLoading:false,
                isReady:true
            })
        });
    }

    _loadData(item){
        this._clearBox();
        this.setState({
            xId:item[0],
            xNama:item[1],
            xAlamat:item[2],
            xNoTlp:item[3]
        })
    }

    _loading(status){
        this.setState({
            isLoading:status
        });
    }

    _notif(type,title,message){
        swal({
            title: title,
            text: message,
            icon: type,
        });
    }

    _add(){
        if(!this.state.xNama){
            this._notif('error', 'Error', 'Name cannot be empty');
            return false;
        };

        var param = {
            nama:this.state.xNama,
            alamat:this.state.xAlamat,
            no_tlp:this.state.xNoTlp
        };


        this._loading(false);
        API.post('supplier', param).then(res=>{
            if(res){
                if(res.data.result){
                    document.getElementById('btn-batal-form').click();
                    this._loading(false);
                    this._clearBox()
                    this._loadDataTable(this.state.fCari);
                }else{
                    this._loading(false);
                    this._notif('error', 'Error', res.data.message);
                    return false;
                }
            }else{
                this._loading(false);
                this._notif('error', 'Error', "Can't connect to server")
                return false;
            }
        }).catch(error=>{
            this._loading(false);
            this._notif('error', 'Error', error.message);
            return false;
        })
    }

    _update(){
        if(!this.state.xNama){
            this._notif('error', 'Error', 'Name cannot be empty');
            return false;
        };

        var params = {
            nama:this.state.xNama,
            alamat:this.state.xAlamat,
            no_tlp:this.state.xNoTlp
        };

        this._loading(false);
        API.put('supplier/'+this.state.xId, params).then(res=>{
            if(res){
                if(res.data.result){
                    document.getElementById('btn-batal-form').click();
                    this._loading(false);
                    this._clearBox()
                    this._loadDataTable(this.state.fCari);
                }else{
                    this._loading(false);
                    this._notif('error', 'Error', res.data.message);
                    return false;
                }
            }else{
                this._loading(false);
                this._notif('error', 'Error', "Can't connect to server.")
                return false;
            }
        }).catch(error=>{
            this._loading(false);
            this._notif('error', 'Error', error.message);
            return false;
        })
    }

    _delete(){
        if(!this.state.xId){
            this._notif('error','Error', 'No data has been selected yet.');
            return false;
        };

        API.delete('supplier/'+this.state.xId).then(res=>{
            if(res){
                if(res.data.result){
                    this._loading(false);
                    this._clearBox();
                    document.getElementById('btn-batal-hapus').click();
                    this._loadDataTable(this.state.fCari);
                }else{
                    this._loading(false);
                    this._notif('error', 'Error', res.data.message);
                    return false;
                }
            }else{
                this._loading(false);
                this._notif('error', 'Error', "Can't connect to server.")
                return false;
            }
        }).catch(error=>{
            this._loading(false);
            this._notif('error', 'Error', error.message);
            return false;
        })
    }

    _submit(){
        if(this.state.xId){
            this._update();
        }else{
            this._add();
        }
    }

    componentDidMount() {
        if(this.state.isLoading){
            if(this.state.isLoading){
                this.setState({
                    isReady:true,
                    isLoading:false
                });
            }
        }
    }

    render(){
        if(!this.state.isReady){
            this.setState({
                isReady:true,
                isLoading:false
            });
            this._loadDataTable(this.state.fCari);
        };

        return(
            <React.Fragment>
                <LoadingScreen
                    loading={this.state.isLoading}
                    bgColor='#f1f1f1'
                    spinnerColor='#9ee5f8'
                    textColor='#676767'
                    logoSrc={logo}
                    text=''
                >
                    <Breadcrumbs title="" breadcrumbItem="Supplier" />
                    <Row>
                        <Col xl={6} md={6} sm={12} xs={12}>
                            <div className="btn-group p-2" role="group">
                                <button type="button" className="btn btn-primary mr-2" data-toggle="modal" data-target="#modal-form" onClick={()=>{
                                    this._clearBox()
                                }}>
                                <i className="fas fa-edit"></i> Add New
                                </button>

                                <button type="button" className="btn btn-primary" onClick={()=>{
                                    window.location.reload(true);
                                }}>
                                <i className="fas fa-recycle"></i> Refresh
                                </button>
                            </div>
                        </Col>
                        <Col xl={6} md={6} sm={12} xs={12}>
                            <div className="input-group p-2">
                                <input type="text" className="form-control" placeholder="Search.." name="fCari" value={this.state.fCari} onChange={this._handleInputChange.bind(this)} onKeyPress={(e)=>{
                                    if(e.key=='Enter'){
                                        document.getElementById('btn-cari').click();
                                    }
                                }} />
                                <button type="button" id="btn-cari" className="btn btn-primary btn-flat" onClick={()=>{this._loadDataTable(this.state.fCari)}}>Cari</button> 
                            </div>
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col xl={12} md={12} sm={12} xs={12}>
                            <div className="card shadow-none border">
                                <div className='card-body'>
                                    <div className="table-responsive">
                                        <table className="table align-middle table-nowrap table-hover mb-0">
                                            <thead>
                                                <tr>
                                                    <th scope="col">NAME</th>
                                                    <th scope="col">ADDRESS</th>
                                                    <th scope="col">PHONE</th>
                                                    <th style={{width:'100px'}}></th> 
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.dataTable.map((item, index)=>{
                                                        return(
                                                            <React.Fragment key={"f_"+index}>
                                                                <tr key={'row_'+index}>
                                                                    <td>{item[1]}</td>
                                                                    <td>{item[2]}</td>
                                                                    <td>{item[3]}</td>
                                                                    <td style={{textAlign:"center", width:'100px'}}>
                                                                    <div className="dropdown">
                                                                        <NavLink to="#" className="font-size-16 text-muted dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true">
                                                                            <i className="fas fa-ellipsis-h fa-lg"></i>
                                                                        </NavLink>
                                                                        <div className="dropdown-menu dropdown-menu-end">
                                                                            <a className="dropdown-item" data-toggle="modal" data-target="#modal-form"  onClick={()=>{
                                                                                this._loadData(item);
                                                                            }}><i className="fas fa-edit mr-2" ></i> Edit</a>
                                                                            <a className="dropdown-item" data-toggle="modal" data-target="#modal-hapus" onClick={()=>{
                                                                                this._loadData(item);
                                                                            }}><i className="fas fa-trash mr-2"></i> Delete</a>
                                                                        </div>
                                                                    </div>
                                                                    </td>
                                                                </tr>
                                                            </React.Fragment>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <div id="modal-form" className="modal fade-scale" tabIndex="-1">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header no-padding">
                                    <h5 className="modal-title"></h5>
                                    <button type="button" className="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div className="modal-body">
                                    <Row>
                                        <Col xl={12} md={12} sm={12} xs={12}>
                                            <div className='profile-user-info profile-user-info-striped'>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Name</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xNama" value={this.state.xNama} onChange={this._handleInputChange.bind(this)} />
                                                    </div>
                                                </div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Address</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xAlamat" value={this.state.xAlamat} onChange={this._handleInputChange.bind(this)} />
                                                    </div>
                                                </div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Phone</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xNoTlp" value={this.state.xNoTlp} onChange={this._handleInputChange.bind(this)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-white btn-primary btn-round" onClick={()=>{
                                        this._submit();
                                        }}>Save</button>
                                    <button id="btn-batal-form" data-dismiss="modal" className="btn btn-white btn-danger btn-round" style={{marginLeft:'5px'}}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="modal-hapus" className="modal fade-scale" tabIndex="-1">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header no-padding">
                                    <h5 className="modal-title"></h5>
                                    <button type="button" className="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div className="modal-body">
                                    <Row>
                                        <Col>
                                            <div className="alert alert-warning">
                                                Deleted data cannot be recovered. Are you sure the data will be deleted?
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-white btn-primary btn-round" onClick={()=>{
                                        this._delete();
                                    }}>Delete</button>
                                    <button id="btn-batal-hapus" data-dismiss="modal" className="btn btn-white btn-danger btn-round" style={{marginLeft:'5px'}}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </LoadingScreen>
            </React.Fragment>
        )
    }



}

export default Supplier;